'use strict';

var angular = require('angular');

require('redi-common-angular');
require('angular-http-auth');

var MODULE_NAME = 'rediIdPWebLib';

var angularModule = angular.module(MODULE_NAME, [
  'redi-common',
  'http-auth-interceptor',
  require('redi-window-container-web-lib-angular')
]);

require('./business/index.js')(angularModule);
require('./infrastructure/index.js')(angularModule);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/index.js
// module id = 109
// module chunks = 0